import Dialog from "@mui/material/Dialog";
import React, { forwardRef } from "react";

import { formatInTimeZone } from "scmp-app/lib/utils";

import {
  CloseButton,
  Footer,
  FooterText,
  Header,
  NewsletterLabel,
  StyledArrowNextIcon,
  StyledCloseIcon,
  StyledIframe,
  Title,
} from "./styles";
import { Transition } from "./transition";

export type Props = {
  className?: string;
  isOpen: boolean;
  newsletterTitle?: string;
  onClose: () => void;
  sourceUrl?: string;
} & React.DetailsHTMLAttributes<HTMLDivElement>;

export const MobileNewsletterPreview = forwardRef<HTMLDivElement, Props>(
  ({ isOpen, newsletterTitle, onClose, sourceUrl }, reference) => (
    <Dialog
      fullScreen
      onClose={onClose}
      open={isOpen}
      ref={reference}
      TransitionComponent={Transition}
    >
      <Header>
        <Title>
          You are reading <NewsletterLabel>{newsletterTitle} newsletter</NewsletterLabel> on{" "}
          {formatInTimeZone(new Date(), "MMMM dd, yyyy")}
        </Title>
        <CloseButton onClick={onClose}>
          <StyledCloseIcon />
        </CloseButton>
      </Header>
      <StyledIframe src={sourceUrl ?? ""} />
      <Footer onClick={onClose}>
        <FooterText>Interested? Sign up now!</FooterText>
        <StyledArrowNextIcon onClick={onClose} />
      </Footer>
    </Dialog>
  ),
);

MobileNewsletterPreview.displayName = "MobileNewsletterPreview";
